let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6j99f")).then(() => parcelRequire('8dVw9'));